export const urlRegexp =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9]{1,6}\b([-a-zA-Z0-9!@:%_\+.~#?&=\/]*)/g;
export const relativeUrlRegexp = /(\/[-a-zA-Z0-9!@:%_\+.~#?&=\/]+\.html)/g;
export const pagePartialRegexp = /\{template\s+.+\}/g;
export const tableClassRegexp = /\n\..+\n+\|/g;
export const translatedH1Section = /^#\s+[^#\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}]+/mu;
export const specialMarkup = /\{.+?\..+?\(.+?\)\}/gm; // NOTE: 特別な記法ではエスケープが使えないので丸ごとブロックにする
export const spreadSheetFunction =
  /QUERY\(.+?\)|Query\(.+?\)|query\(.+?\)|INDEX\(.+?\)|Index\(.+?\)|index\(.+?\)|MATCH\(.+?\)|Match\(.+?\)|match\(.+?\)/g;
